export default __webpack_public_path__ + "static/media/designer-icon.df65742d.svg";